function migrateToShop479(state: any): any {
  return { ...state, flow: { ...state.flow, backendRegions: [] } };
}

export default migrateToShop479;
